import React, { PropsWithChildren } from "react";

interface Props {
  to: string;
}

const FooterSocialLink = ({ to, children }: PropsWithChildren<Props>) => {
  return (
    <a
      href={to}
      className="hover:bg-grey-medium-3 flex h-[30px] w-[30px] items-center justify-center rounded-full bg-white"
    >
      {children}
    </a>
  );
};

export default FooterSocialLink;
